export default class NcdDetails {
  constructor(years, protectedNcd, dateExpiry) {
    this.years = years;
    this.noNcdReasonId;
    this.entitlementReasonId;
    this.typeId;
    this.countryEarnedId;
    this.protected = protectedNcd;
    this.dateExpiry = dateExpiry;
  }
}
